var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.33398,
    y: 5.3335,
    width: 37.3333,
    height: 37.3333,
    rx: 18.6667,
    fill: "#C1AB52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4668,
    y: 7.4668,
    width: 33.0667,
    height: 33.0667,
    rx: 16.5333,
    fill: "#EDE6CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5164 13.9107C23.6763 13.8965 23.8314 13.8827 23.9793 13.8667C26.6516 14.0084 28.8527 14.8227 30.2067 17.0974C31.5244 19.314 31.02 21.8029 28.9457 23.4128C28.6262 23.661 28.2934 23.8935 27.9605 24.1261C27.6029 24.376 27.2452 24.6259 26.9039 24.8952C26.0813 25.546 25.5445 26.3836 25.2654 27.3816C24.9963 28.3434 24.5358 28.8 23.9302 28.8C23.3125 28.8 22.8412 28.2929 22.5647 27.3253C21.9833 25.2912 22.8047 23.1715 24.6975 21.8243C24.7893 21.7587 24.8827 21.6947 24.9761 21.6307C25.2024 21.4757 25.4289 21.3204 25.6341 21.1419C26.2093 20.6406 26.6065 20.0481 26.3226 19.2629C26.028 18.4499 25.326 18.111 24.504 18.0327C23.5087 17.937 22.5768 18.1685 21.7643 18.7597C21.7137 18.7963 21.6625 18.8314 21.6111 18.8666C21.5871 18.8831 21.5631 18.8995 21.5391 18.9162C20.45 19.671 19.4271 19.6736 18.7386 18.9233C17.891 17.9991 17.9348 16.6053 18.8667 15.7373C19.8377 14.8317 21.0191 14.2942 22.3408 14.0523C22.7362 13.9801 23.1393 13.9442 23.5164 13.9107Z",
    fill: "#A48300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4004 32.4779C22.3974 30.8843 23.2265 29.8696 24.5334 29.8667C25.8294 29.8637 26.6613 30.8843 26.667 32.4844C26.6734 34.0554 25.7643 35.1949 24.4977 35.2C23.2917 35.205 22.4027 34.054 22.4004 32.4779Z",
    fill: "#A48300"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.43abb84ebc11e684e92f29c05c0651c5.svg";
export { ForwardRef as ReactComponent };